<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close(false)">Cancel</button>
  <button
    mat-flat-button
    [color]="data.danger ? 'warn' : 'primary'"
    (click)="close(true)"
  >
    {{ data.confirmLabel }}
  </button>
</mat-dialog-actions>
